function cleanRef(ref, prefix) {
  if (!prefix) {
    return ref;
  }
  if (ref.startsWith(prefix)) {
    return `/page/${ref.slice(prefix.length)}`;
  }
  return ref;
}
export {
  cleanRef
};
//# sourceMappingURL=clean-ref.js.map
